import type { ReactNode } from 'react'
import { cn } from '@/utils/twMerge'
import { PrismicLink, PrismicRichText } from '@prismicio/react'
import type { NavbarResourcesDropdownProps } from '@/types/navbarDropdown'
import NavbarDropdownIcon from '@/components/navbar/NavbarDropdownIcon'

const Paragraph = ({ index, children }: { index: number; children: ReactNode }) => (
  <p
    className={cn(
      '!leading-[140%] tracking-[0.16px]',
      index === 0 && 'text-sm font-normal',
      index === 1 && 'font-halyardDisplay text-sm font-medium 1xl:text-base',
    )}>
    {children}
  </p>
)

const ResourcesDropdownData = ({ data }: NavbarResourcesDropdownProps) => {
  return (
    <div className="dropdown-menu">
      <div className="container-fluid">
        <div className="dropdown-menu-wrapper">
          <div className="resources-nav-content col-span-6">
            <div>
              <h4 className="mb-6">{data.resources_text}</h4>

              <div className="resources-nav-content-items">
                {data.resources.map((item, index) => {
                  return (
                    <PrismicLink field={item.resources_link_url} key={index}>
                      <div className="resources-nav-content-item">
                        <NavbarDropdownIcon field={item.resources_icon} />

                        <div className="flex flex-col gap-1">
                          <span className="block font-halyardDisplay text-base font-medium !leading-[110%] tracking-[0.16px] text-primary-ink-100">
                            {item.resources_title}
                          </span>
                          <span className="block text-base font-normal !leading-[150%] tracking-[0.16px] text-primary-ink-85">
                            {item.resources_description}
                          </span>
                        </div>
                      </div>
                    </PrismicLink>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="framework-resources-nav-content col-span-4">
            <h4 className="mb-6">{data.framework_resources_text}</h4>

            <div className="grid grid-cols-2 gap-x-4">
              <div className="framework-resources-nav-content-items">
                {data.framework_resources.map((item, index) => {
                  const key = `i-${index}`

                  return item.link_title === 'CMMC Hub' ? (
                    <PrismicLink href="/hub/cmmc" key={key}>
                      <div className="framework-resources-nav-content-item">
                        <NavbarDropdownIcon field={item.icon} size={20} />

                        <div className="flex flex-col gap-1">
                          <span className="block font-halyardDisplay text-sm font-medium !leading-[140%] tracking-[0.16px] 1xl:text-base">
                            {item.link_title}
                          </span>
                        </div>
                      </div>
                    </PrismicLink>
                  ) : (
                    <PrismicLink field={item.link_url} key={key}>
                      <div className="framework-resources-nav-content-item">
                        <NavbarDropdownIcon field={item.icon} size={20} />

                        <div className="flex flex-col gap-1">
                          <span className="block font-halyardDisplay text-sm font-medium !leading-[140%] tracking-[0.16px] 1xl:text-base">
                            {item.link_title}
                          </span>
                        </div>
                      </div>
                    </PrismicLink>
                  )
                })}
              </div>

              <div className="framework-resources-kit-nav-content-items">
                {data.framework_resources_kit.map((item, index) => {
                  const key = `i-${index}`
                  return (
                    <PrismicLink field={item.link_url} key={key}>
                      <div className="framework-resources-kit-nav-content-item">
                        <NavbarDropdownIcon field={item.icon} size={20} />

                        <div className="flex flex-col gap-1">
                          <span className="block font-halyardDisplay text-sm font-medium !leading-[140%] tracking-[0.16px] 1xl:text-base">
                            {item.link_title}
                          </span>
                        </div>
                      </div>
                    </PrismicLink>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="customer-resources-nav-content col-span-3">
            <h4 className="mb-6">{data.customer_resources_text}</h4>

            <div className="customer-resources-nav-content-items">
              {data.customer_resources.map((item, index) => {
                const key = `i-${index}`
                return (
                  <PrismicLink field={item.link_url} key={key}>
                    <div className="customer-resources-nav-content-item">
                      <NavbarDropdownIcon field={item.icon} size={20} />

                      <div>
                        <PrismicRichText
                          field={item.link_title}
                          components={{
                            paragraph: ({ children }) => <Paragraph index={index}>{children}</Paragraph>,
                          }}
                        />
                      </div>
                    </div>
                  </PrismicLink>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResourcesDropdownData
